<template>

<core-panel>

	<template v-slot:head>

		<h1>Recent Plays</h1>

	</template>

	<template v-slot:body>

		<app-game :item="item" v-for="(item, index) in list" :key="index" :subtext="item.date | fromNow" :date="item.date" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'recent',
			list: []
		}

	},

	methods: {

		response: function(json) {

			this.list = json.recent.list

		}

	}

}

</script>